import { h } from 'preact';
import clsx from 'clsx';
import { useState } from 'preact/hooks';
import ColumnInnerMedia from './column-inner-media';
import ColumnInnerContent from './column-inner-content';
import CloseBig from '../utils/icon/close-big.svg';

const ColumnInner = ({
  mediaData,
  contentData,
  index,
  handleColumnClose,
  isHovered,
  isOpened,
  isLifestyleImageBordered,
  lifestyleImageBorderColor,
  isMobile
}) => {
  const [currentMediaItem, setCurrentMediaItem] = useState(0);
  const dynamicClass = (i) =>
    i > 2
      ? 'flex-col-reverse laptop:flex-row-reverse'
      : 'media-left flex-col laptop:flex-row';
  const ANIMATION_CLASS = 'transition-all duration-500 ease-in-out'

  return (
    <column-inner className={`flex h-full ${isMobile ? 'flex-col' : dynamicClass(index)}`}>
      <close-column-modal
        className={clsx(
          `${index < 2 ? 'laptop:text-black' : ''}`,
          'block absolute z-[0] cursor-pointer right-[20px] top-[20px]',
          'scale-[.8] opacity-0',
          ANIMATION_CLASS,
          '[.is-active_&]:opacity-100 [.is-active_&]:z-[5]'
        )}
        onClick={handleColumnClose}
      >
        <CloseBig />
      </close-column-modal>
      <column-inner-media className={ clsx(
        'flex w-full min-h-[430px] laptop:h-full laptop:w-1/2 relative',
        ANIMATION_CLASS,
      )
        }>
        <ColumnInnerMedia
          data={mediaData}
          isHovered={isHovered}
          isOpened={isOpened}
          currentMediaItem={currentMediaItem}
          isLifestyleImageBordered={isLifestyleImageBordered}
          lifestyleImageBorderColor={lifestyleImageBorderColor}
        />
      </column-inner-media>
      <column-inner-content className={clsx(
        'flex w-full h-full laptop:w-1/2 bg-neutral text-black',
        ANIMATION_CLASS,
        )
      }>
        <ColumnInnerContent
          data={contentData}
          setCurrentMediaItem={setCurrentMediaItem}
        />
      </column-inner-content>
    </column-inner>
  );
};

export default ColumnInner;
